.field {
  position: relative;
  padding-bottom: 20px;
  width: 100%;
}
.invalidInputText {
  color: var(--sentiment-text-negative);
  font-size: var(--fs-x-small);
  position: absolute;
  bottom: 0;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.invalidInputText.left {
  left: 0;
}
.invalidInputText.right {
  right: 0;
}
.invalidInputText::after {
  content: "\A0";
}
